import {
  DollarOutlined,
  BookOutlined,
  AccountBookOutlined,
  CreditCardOutlined,
  WalletOutlined,
  PieChartOutlined,
  LineChartOutlined,
  FundOutlined,
  FileDoneOutlined,
  GlobalOutlined,
} from '@ant-design/icons';
import type { SidebarConfig } from './types';

export const financeSidebar: SidebarConfig = {
  module: 'finance',
  titleKey: 'common:nav.finance',
  icon: <DollarOutlined />,
  sections: [
    {
      key: 'ledger',
      labelKey: 'finance:sidebar.sections.ledger',
      items: [
        { key: 'coa', path: '/finance/coa', labelKey: 'finance:pages.coa', icon: <BookOutlined /> },
        { key: 'gl', path: '/finance/gl', labelKey: 'finance:pages.gl', icon: <AccountBookOutlined /> },
      ],
    },
    {
      key: 'subledgers',
      labelKey: 'finance:sidebar.sections.subledgers',
      items: [
        { key: 'ap', path: '/finance/ap', labelKey: 'finance:pages.ap', icon: <CreditCardOutlined /> },
        { key: 'ar', path: '/finance/ar', labelKey: 'finance:pages.ar', icon: <WalletOutlined /> },
      ],
    },
    {
      key: 'planning',
      labelKey: 'finance:sidebar.sections.planning',
      items: [
        { key: 'budget', path: '/finance/budget', labelKey: 'finance:pages.budget', icon: <PieChartOutlined /> },
        { key: 'cost-control', path: '/finance/cost-control', labelKey: 'finance:pages.costControl', icon: <LineChartOutlined /> },
        { key: 'cash-flow', path: '/finance/cash-flow', labelKey: 'finance:pages.cashFlow', icon: <FundOutlined /> },
      ],
    },
    {
      key: 'reporting',
      labelKey: 'finance:sidebar.sections.reporting',
      items: [
        { key: 'statements', path: '/finance/statements', labelKey: 'finance:pages.statements', icon: <FileDoneOutlined /> },
        { key: 'vat-currency', path: '/finance/vat-currency', labelKey: 'finance:pages.vatCurrency', icon: <GlobalOutlined /> },
      ],
    },
  ],
};
